<template>
  <div>
    <el-container>
      <!-- 顶部 -->
      <el-header>
        <div>
          <div class="bamtopclass">辅导员管理系统</div>
          <div class="removeLogin">
            <el-button type="primary" @click="outlogin"> 退出登录</el-button>
          </div>
          <div><span class="username">{{ username }}</span></div>
        </div>
      </el-header>
      <el-container class="home_class">
        <el-aside width="200px">
          <!-- 左侧 -->
          <el-menu router>
            <!-- 一级菜单 -->
            <el-submenu index="1">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-xueshengguanli"></span>
                <span>学生管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="ViewStudentInfo">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>学生信息列表</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="VieApponintments">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-daoru"></span>
                    <span>学生预约查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="VieTeacherApponintments">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-daoru"></span>
                    <span>已预约列表</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="InstructorSupervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >填写学风督查</span>
        </template>
          </el-menu-item>

          
          <el-menu-item index="InstructorViewSupervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span>查看学风督查</span>
        </template>
          </el-menu-item>

          <el-menu-item index="viewStudentDorm">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span>宿舍信息查看</span>
        </template>
          </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 一级菜单 -->
            <el-submenu index="2">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-huibao"></span>
                <span>工作汇报</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="InstructorPeport">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>工作汇报查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <!-- 二级菜单 -->
              <!-- <el-menu-item-group>
                <el-menu-item index="InstructorKpi">
                  <template slot="title">
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>KPI填写</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group> -->
              <el-menu-item-group>
                <el-menu-item index="instructorPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>周绩效填写</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="viewWeekIPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>周绩效查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="viewMonthIPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>月绩效查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <!-- <el-menu-item-group>
                <el-menu-item index="ViewInstructorKpi">
                  <template slot="title">
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>KPI查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group> -->
            </el-submenu>
            <el-submenu index="44">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>文件管理</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group>
          <el-menu-item index="InstructorCloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>文件上传</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="InstructorPublicCloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>公用文件</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>
            <el-submenu index="3">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-gerenxinxi1"></span>
                <span>个人信息</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="InstrutorEVPI">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-yonghuguanli"></span>
                    <span>个人信息完善</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <router-view></router-view>
          </el-main>
          <el-footer>Footer</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import "@/components/work/until/icon/iconfont.css"
export default {
  created() {
    this.newscli()
  },
  methods: {
    newscli() {
      this.username = JSON.parse(localStorage.getItem('user')).username
    },
    outlogin() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.$router.push({
        name: 'Login',
      })
    }, data() {
      return {
        username: '',
      }
    },
  }

}
</script>
  
<style scoped>
.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
  min-width: 1400px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  min-width: 1200px;
}

.home_class {
  height: 800px;
}

.removeLogin {
  float: right;
}

.bamtopclass {
  float: left;
  padding-left: 45%;
}

.username {
  padding-left: 38%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/instructor/InstructorBam.vue